import moment from "moment";
import { mapGetters } from "vuex";
import { PostalAddress } from "@/components/Elements";
import { formatDateTime } from "@/components/mixins/"

export default {
  name: "MleInvoiceDetailsHeader",
  components: {
    PostalAddress,
  },
  mixins: [formatDateTime],
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(["getContentItem", "IsMcfe", "hasPermission"]),
    shipToDealerCode() {
      return this.data.CustomerNumber;
    },
  },
  methods: {
    print(){
      window.print();
    },

    formatDate: function(value) {
      return moment(value).format("MMM D, YYYY");
    },

    getAddress: function(address) {
      if (!address) {
        return null;
      }

      return {
        ...address,
        Name: address.Name1,
        AddressLine1: address.Street1,
        AddressLine2: address.Street2,
        AddressLine3: address.Street3
      };
    },
  }
};